import _ from 'lodash';

export const typeAheadListFiltering = (typedValue, inputLength, list) => {
  return (typedValue < inputLength) ? [] : _.filter(list, (op) => {
    return (op.name.toUpperCase().includes(typedValue.toUpperCase()));
  });
};
